import PlatformEvent from "../PlatformEvent"

export default new PlatformEvent("INFO", "Navigating")